var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppHeaderDropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"header"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"https://upload.wikimedia.org/wikipedia/commons/1/1e/Default-avatar.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v("\\\n  "),_c('template',{slot:"dropdown"},[_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("Conta")])]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Sair")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/containers/DefaultHeaderDropdownAccnt.vue?vue&type=template&id=9eb68f54
// module id = null
// module chunks = 